import React from 'react';

const ImageComparison = ({ beforeLabel, afterLabel, beforeImage, afterImage }) => {
  return (
    <div className="relative h-64 bg-gray-200 overflow-hidden rounded-t-2xl">
      <div className="absolute inset-0 flex">
        {/* Before Image */}
        <div className="w-1/2 flex items-center justify-center">
          <div className="text-center">
            <div className="bg-gray-600 text-white text-xs px-2 py-1 rounded-full mb-2">
              {beforeLabel}
            </div>
            <img 
              src={beforeImage} 
              alt={beforeLabel}
              className="w-32 h-24 object-cover rounded-lg"
            />
          </div>
        </div>
        
        {/* After Image */}
        <div className="w-1/2 flex items-center justify-center">
          <div className="text-center">
            <div className="bg-pink-accent text-white text-xs px-2 py-1 rounded-full mb-2">
              {afterLabel}
            </div>
            <img 
              src={afterImage} 
              alt={afterLabel}
              className="w-32 h-24 object-cover rounded-lg"
            />
          </div>
        </div>
        
        {/* Vertical Divider */}
        <div className="absolute left-1/2 top-0 bottom-0 w-1 bg-white shadow-lg">
          <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-4 h-4 bg-gray-600 rounded-full"></div>
        </div>
      </div>
    </div>
  );
};

export default ImageComparison; 